module.exports = __webpack_public_path__ + "static/media/united-way.ed56a1e6.PNG";